export const COVERAGE_LIST = [
  "Cards that are not active",
  "Cards with an inaccurate balance",
  "Cards delivered as a different brand than ordered on GCX"
];

export const UNCOVERAGE_LIST = [
  "Requests received outside of 90 days",
  "Buyer’s remorse or change of mind",
  "Misinterpretation of card delivery method or timing of delivery",
  "Misinterpretation of how a particular card is redeemed or any other redemption requirements or limitations",
  "Neglecting to apply a promotional code before a purchase",
  "Cards lost or misplaced by the buyer",
  "Cards merged onto external merchant apps or accounts against GCX Terms of Use, which could result in loss of card value",
  "Cards that are subsequently resold on any platform other than GCX or given to someone other than the original purchaser (other than gifts sent through GCX)",
  "Cards you have purchased on GCX at the request of a third party and which cards you then share or provide to a third party",
  "Cards not received due to incorrect shipping or delivery information",
  "Cards that are no longer honored when a retailer goes out of business or files for bankruptcy",
  "Cards for which a merchant has changed its redemption policies and/or procedures, provided the card can still be redeemed at the merchant",
  "Cards that have expired pursuant to a particular merchant’s gift card terms"
];
